import { render, staticRenderFns } from "./InputGroupText.vue?vue&type=template&id=3eafdae4&"
import script from "./InputGroupText.vue?vue&type=script&lang=js&"
export * from "./InputGroupText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports